import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { appShapes } from 'App/duck';
import blocks from '../../blocks';
import elements from '../../elements';
import './ChannelsComponent.scss';
import { getUserId } from '../../../../../helpers/cookies';
class ChannelsComponent extends React.Component {
  state = {
    sortedChannels: [],
  };

  componentDidMount() {
    const { active, channels, setActiveChannel } = this.props;
    if (!channels.loading && Array.isArray(channels.data) && channels.data.length > 0) {
      const sorted = this.sortChannelWithNullValues([...channels.data], false);
      const matchedChannel = sorted.find((channel) => channel.id === active);
      setActiveChannel(matchedChannel ? matchedChannel.id : sorted[0].id);
      this.setState({ sortedChannels: sorted });
    }
  }

  componentDidUpdate(prevProps) {
    const { active, channels, setActiveChannel } = this.props;
    if (prevProps.channels !== channels) {
      const sorted = this.sortChannelWithNullValues([...channels.data], false);

      if (sorted.length > 0) {
        const matchedChannel = sorted.find((channel) => channel.id === active);
        const shouldUpdate =
          !prevProps.channels.data ||
          prevProps.channels.data.length !== channels.data.length ||
          channels.data.some((channel, i) => channel.id !== prevProps.channels.data[i]?.id);

        if (shouldUpdate) {
          setActiveChannel(matchedChannel ? matchedChannel.id : sorted[0].id);
        }
      } else {
        setActiveChannel(null);
      }

      this.setState({ sortedChannels: sorted });
    }
  }


  handleChannelClicked = (channelId) => {
    const { setActiveChannel, ResetNotifyNewPost } = this.props;
    setActiveChannel(channelId);
    ResetNotifyNewPost(channelId);
  };

  sortChannelWithNullValues = (arr, ascending = true) => {
    const multiplier = ascending ? 1 : -1;
    return arr.sort((a, b) => {
      if (a.updated_at === b.updated_at) return 0;
      if (!a.updated_at) return 1;
      if (!b.updated_at) return -1;
      return a.updated_at.localeCompare(b.updated_at) * multiplier;
    });
  };

  handleLeaveChannel = (channelId) => {
    console.log('Delete chat:', channelId);
    const { handleRemoveUserFromGroup, allUsers } = this.props;
    const currentUserId = parseInt(getUserId());
    const currentUser = allUsers.find((user) => user.owner_id === currentUserId);

    if (currentUser) {
      handleRemoveUserFromGroup(channelId, [currentUser]);
    }
  };

  handleMuteGroup = (channelId, subscriptionId, muteStatus) => {
    const { updateChannelMuteStatus } = this.props;
    //updateChannelMuteStatus(channelId, subscriptionId, muteStatus);
  };

  render() {
    const { channels, active, locations, locationId } = this.props;
    const { sortedChannels } = this.state;

    return (
      <elements.ColumnWrap maxWidth="360px">
        <elements.ScrollWrap>
          {!channels.loading && sortedChannels.map((channel) => (
            <blocks.Channel
              key={channel.id}
              active={channel.id === active}
              channel={channel}
              handleClick={() => this.handleChannelClicked(channel.id)}
              locations={locations}
              locationId={locationId}
              onDelete={this.handleLeaveChannel}
              onMute={this.handleMuteGroup}
            />
          ))}
        </elements.ScrollWrap>
      </elements.ColumnWrap>
    );
  }
}

ChannelsComponent.propTypes = {
  setActiveChannel: PropTypes.func.isRequired,
  channels: appShapes.channelsShape.isRequired,
  active: PropTypes.number.isRequired,
  ResetNotifyNewPost: PropTypes.func.isRequired,
  locations: PropTypes.array,
  locationId: PropTypes.number,
};

export default ChannelsComponent;
